// 抑制 Element Plus 常见的良性 ResizeObserver 循环报错
const resizeObserverLoopErrRe = /^ResizeObserver loop/
window.addEventListener('error', (e) => {
    if (e.message && resizeObserverLoopErrRe.test(e.message)) {
        e.stopImmediatePropagation()
        e.preventDefault()
        return false
    }
})
import { createHead } from '@vueuse/head'
import { createApp } from 'vue'

import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/styles/theme.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import { registerVideoCache } from './js/videoCache'
import { bindAuthRouter } from './js/connect'

const app = createApp(App)
const head = createHead()

app.use(head)
app.use(router)
app.use(ElementPlus)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
bindAuthRouter(router)
app.mount('#app')
registerVideoCache()
